(function () {
  'use strict';

  var sent = {};
  var device = window.innerWidth < 750 ? 'mobile' : (window.innerWidth < 1024 ? 'tablet' : 'desktop');
  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  var market = document.documentElement.lang || window.location.pathname.split('/')[1] || 'default';

  function send(name, params) {
    if (!window.gtag || sent[name]) return;
    sent[name] = true;
    window.gtag('event', name, Object.assign({
      device_category: device,
      market: market,
      currency: currency
    }, params || {}));
  }

  function productMeta() {
    var product = window.ShopifyAnalytics && window.ShopifyAnalytics.meta && window.ShopifyAnalytics.meta.product;
    return product ? {
      item_id: String(product.id || ''),
      item_name: product.title || product.name || '',
      value: Number(product.price || 0) / 100
    } : {};
  }

  function isCheckoutIntent(target) {
    var link = target && target.closest && target.closest('a,button,input');
    if (!link) return false;
    var text = (link.textContent || link.value || '').toLowerCase();
    var href = link.getAttribute('href') || '';
    return href.indexOf('/checkout') !== -1 || text.indexOf('checkout') !== -1 || text.indexOf('pagar') !== -1 || text.indexOf('finalizar') !== -1;
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (window.location.pathname.indexOf('/products/') === 0) send('view_item', productMeta());

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (form.action && form.action.indexOf('/cart/add') !== -1) {
        var id = form.querySelector('[name="id"]');
        var quantity = form.querySelector('[name="quantity"]');
        send('add_to_cart', Object.assign(productMeta(), {
          item_id: id ? String(id.value) : productMeta().item_id,
          quantity: quantity ? Number(quantity.value || 1) : 1
        }));
      }
    }, true);

    document.addEventListener('click', function (event) {
      if (isCheckoutIntent(event.target)) send('begin_checkout', {});
    }, true);
  });
}());
